import { ApiResult } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CONFIGURACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'any' })
export class ReCaptchaDataService {

    protected url: string;

    constructor(
        @Inject(CONFIGURACAO_API_URL) urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {

        this.url = `${urlBase}/v1/ReCaptcha`;
    }

    confirmarToken(token: string, acao: string) {

        return this.httpClient.get<ApiResult<boolean>>(
            this.url +"/ValidarToken", {
                params: {
                    recaptchaToken: token,
                    acao: acao
                } });
    }

}
